import { EditSupportTaskOutDto, EditSupportTaskInDto } from '../../../types/support-tasks.dto'

export const EDIT_SUPPORT_TASK = 'EDIT_SUPPORT_TASK'
export const EDIT_SUPPORT_TASK_SUCCESS = 'EDIT_SUPPORT_TASK_SUCCESS'
export const EDIT_SUPPORT_TASK_ERROR = 'EDIT_SUPPORT_TASK_ERROR'
export const RESET_EDIT_SUPPORT_TASK = 'RESET_EDIT_SUPPORT_TASK'

export interface EditSupportTask {
  type: typeof EDIT_SUPPORT_TASK
  payload: EditSupportTaskOutDto
}

export interface EditSupportTaskSuccess {
  type: typeof EDIT_SUPPORT_TASK_SUCCESS
  payload: EditSupportTaskInDto
}

export interface EditSupportTaskError {
  type: typeof EDIT_SUPPORT_TASK_ERROR
  payload: string | boolean
}

export interface ResetEditSupportTask {
  type: typeof RESET_EDIT_SUPPORT_TASK
  payload: null
}
export interface State {
  data: EditSupportTaskInDto | null
  states: {
    loading: boolean
    success: boolean
    error: boolean | string
  }
}

export const initialState: State = {
  data: null,
  states: {
    loading: false,
    success: false,
    error: false,
  },
}

export type Actions = EditSupportTask | EditSupportTaskSuccess | EditSupportTaskError | ResetEditSupportTask
